import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { DatePipe } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-session-cutoff-model-pop',
  templateUrl: './session-cutoff-model-pop.component.html',
  styleUrls: ['./session-cutoff-model-pop.component.scss']
})
export class SessionCutoffModelPopComponent implements OnInit {
  SessionCutOff: FormGroup;
  submitButton = true;
  subButton = false
  editButton = false;
  SessionFilterList: any;
  isdisabled = false;
  sessionList: any;
  collegeList: [];
  Table = false;
  filteredCollegeList: any;
  CourseList: any;
  filteredCourseList: any;
  userPermission: any;
  filteredListFcCode: any;
  fcCodeList: any[] = [];
  utp: any;
  sessCreate = true;
  sessUpdate = true;
  disableDate = false;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<SessionCutoffModelPopComponent>;
  DateArray: FormArray;
  CoCode: any;
  CoName: any;
  SnNo: any;
  ShId: any;
  submitpayload: any;
  currentdate;
  selectedDate: Date;
  errMsg: any;
  datearr: any;
  date: string;
  APIService: string;
  ExamAList: any;
  filteredExamAList: any;
  ExamInputList: any;
  filteredExamInputList: any;
  examDropdownVisible: boolean;
  UserCollege
  SelectAllActive: boolean = false;
  isSelectAll: boolean = false;  // Flag to disable other options
  selectedColleges = [];  // Array to store selected college codes
  selectedCourses = [];   // Array to store selected course codes
  selectedExams = [];     // Array to store selected exam IDs
  commaSeparatedColleges: string;
  commaSeparatedCourses: string;
  commaSeparatedExams: string;
  constructor(public umsService: UmsService, public datepipe: DatePipe,
    private modalPopupService: ModalpopService,
    public dialogRef2: MatDialogRef<SessionCutoffModelPopComponent>,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder, private httpClient: HttpClient, public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,) { this.APIService = environment.serviceUrl }
  todayDate: Date = new Date();
  ngOnInit(): void {
    // Initialize selection arrays
    this.selectedColleges = [];
    this.selectedCourses = [];
    this.selectedExams = [];

    this.Table = false;
    this.isSelectAll = true
    this.currentdate = new Date().setHours(0, 0, 0, 0);
    this.date = this.datepipe.transform(this.currentdate, 'yyyy-MM-dd');
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Session-Cutoff' && element.PCreate == false) {
          this.sessCreate = false;
        }
        if (element.PageName == 'Session-Cutoff' && element.PUpdate == false) {
          this.sessUpdate = false;
        }
      });
    }
    this.subButton = false;
    this.disableDate = false;
    this.SessionCutOff = this.fb.group({
      DateArray: this.fb.array([]),
      SessionID: new FormControl('', [Validators.required]),
      CoCgCgCode: new FormControl('', [Validators.required]),
      CoCgCoCode: new FormControl([], [Validators.required]), // changed to array for multi-select
      EmId: new FormControl([], [Validators.required]), // changed to array for multi-select
      CoFcCode:new FormControl(''),
      InCode: new FormControl('', [Validators.required]),
      // CutOffDate: new FormControl ('',[Validators.required]),
      SearchString: new FormControl(''),
      AMD: new FormControl(''),
    });

    if (this.data.key == "Edit") {
      this.prepopulateRecord(this.data.selected);

    }
    else if (this.data.key == "New") {
      this.fetchSecretData();
      this.initLoad();
    }
    this.action('d');
    
    this.fetchSupExamInputs();
  }

  isDatePassed(cutOffDate: Date): boolean {
    const todayDate = new Date(); // Get today's date
    const cutOff = new Date(cutOffDate); // Parse the cutOffDate into a Date object

    // Set time component to 00:00:00 for both dates
    todayDate.setHours(0, 0, 0, 0);
    cutOff.setHours(0, 0, 0, 0);

    // Check if cutOffDate is greater than today's date or same as today's date
    return cutOff < todayDate;
  }

  dateFilter = (date: Date | null): boolean => {
    let datesArray = this.SessionCutOff.get('DateArray') as FormArray;
    let dateValue = datesArray.value;
    const lastItem = dateValue[dateValue.length - 1];
    const hasEmptyCutOffDateFrom = dateValue.some(item => item.CutOffDateFrom === '' || item.CutOffDate === '' || item.CutOffDateFrom === null || item.CutOffDate === null);
    if (datesArray.value[0]['CutOffDate'] == '' || hasEmptyCutOffDateFrom) {
      this.disableDate = false
      if (!date) {
        const today = new Date().setHours(0, 0, 0, 0);
        return true; // Allow current date or future dates
      }

      const selectedDate = new Date(date).setHours(0, 0, 0, 0);
      const today = new Date().setHours(0, 0, 0, 0);
      // Compare selected date with today's date
      return selectedDate >= today;

    }
    else if (lastItem) {
      const today = new Date().setHours(0, 0, 0, 0);
      const cutOffDateFrom = this.datepipe.transform(lastItem.CutOffDateFrom, 'yyyy-MM-dd');
      const cutOffDate = this.datepipe.transform(lastItem.CutOffDate, 'yyyy-MM-dd');
      const todayFormatted = this.datepipe.transform(today, 'yyyy-MM-dd');
      const hasDate = cutOffDateFrom >= todayFormatted && cutOffDate >= todayFormatted;
      const hasdates = cutOffDateFrom < todayFormatted && cutOffDate < todayFormatted;
      if (hasdates) {
        this.disableDate = true;
      }
      else if (hasEmptyCutOffDateFrom) {
        this.disableDate = false
      }
      else {
        this.disableDate = false
      }


      if (hasDate) {
        const selectedDate = new Date(date).setHours(0, 0, 0, 0);
        const today = new Date().setHours(0, 0, 0, 0);
        // Compare selected date with today's date
        return selectedDate >= today;
      }
      else {
        return true;
      }
    }

    else {
      return true;
    }


  };

  action(d) {
    let taskListArrays = this.SessionCutOff.get('DateArray') as FormArray;
    if (taskListArrays.length >= 2) {
      let ttsskk = taskListArrays.length - 1;
      for (let index = 0; index <= ttsskk; index++) {
        const element = taskListArrays.controls[index];
        if (element.status == 'INVALID') {
          taskListArrays.controls[index].get('CutOffDate').setErrors(null)
          taskListArrays.controls[index].get('CutOffDateFrom').setErrors(null)
        }
      }
    }
  }

  datechange(i) {
    let taskListArrays = this.SessionCutOff.get('DateArray') as FormArray;
    if (taskListArrays.controls[i].value.AMD == 'A') {
    } else {
      taskListArrays.controls[i].patchValue({ "AMD": "M" });
    }
    let formattedDate = this.datepipe.transform(taskListArrays.controls[i].value['CutOffDateFrom'], 'yyyy-MM-dd');
    if (taskListArrays.controls[i].value['CutOffDateFrom'] < this.currentdate || formattedDate < this.currentdate) {
      let data = []
      data['message'] = "Date Cannot Be Less Than Today's Date";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      // taskListArrays.controls[i]['CutOffDateFrom'].setValue('')
      taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
      taskListArrays.controls[i].get('CutOffDateFrom').setErrors({ TodaydateError: true });
    }

    else {
      taskListArrays.controls[i].get('CutOffDateFrom').setErrors(null);
    }
    const formattedDateAsString = this.datepipe.transform(taskListArrays.controls[i].value.CutOffDateFrom, 'yyyy-MM-dd');
    if((formattedDateAsString > taskListArrays.controls[i].value.CutOffDate) && taskListArrays.controls[i].value.CutOffDate != ''){
      let data = {};
      data['message'] = "From Date Cannot Be Greater Than ToDate";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      // taskListArrays.controls[i]['CutOffDateFrom'].setValue('')
      taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
    }

    if (taskListArrays.controls[i].value.CutOffDate != '' || taskListArrays.controls[i].value.CutOffDate == null) {

      if (taskListArrays.controls[i].value.CutOffDateFrom > taskListArrays.controls[i].value.CutOffDate) {
        let data = {};
        data['message'] = "From Date Cannot Be Greater Than ToDate";
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        // taskListArrays.controls[i]['CutOffDateFrom'].setValue('')
        taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
      }
    }
   
    if(i > 0){
      const previousToDate = new Date(taskListArrays.controls[i - 1].value['CutOffDate']);
    const formattedDateAsString = this.datepipe.transform(previousToDate, 'yyyy-MM-dd');
    
    if (formattedDate === formattedDateAsString) {
      // taskListArrays.controls[i].get('CutOffDateFrom').setErrors({ SameDateError: true });
      let data = []
      data['message'] = "From Date Cannot Be Same As Previous ToDate";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
    }
    else if(formattedDate < formattedDateAsString){
      let data = []
      data['message'] = "From Date Cannot Be Less Than Previous ToDate";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
    }
    else {
      taskListArrays.controls[i].get('CutOffDateFrom').setErrors(null);
    }
    }
  }

  datechange1(i) {
    let taskListArrays = this.SessionCutOff.get('DateArray') as FormArray;
    this.isDatePassed(taskListArrays.controls[i].value['CutOffDate'])
    let formattedDated = this.datepipe.transform(taskListArrays.controls[i].value['CutOffDate'], 'yyyy-MM-dd');
    if (taskListArrays.controls[i].value['CutOffDate'] < this.currentdate || formattedDated < this.currentdate) {
      let data = []
      data['message'] = "Date Cannot Be Less Than Today's Date";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      // taskListArrays.controls[i]['CutOffDateFrom'].setValue('')
      taskListArrays.controls[i].get('CutOffDate').setValue('');
    }

    else {
      taskListArrays.controls[i].get('CutOffDate').setErrors(null);
    }
    if (taskListArrays.controls[i].value.AMD == 'A') {
    } else {
      taskListArrays.controls[i].patchValue({ "AMD": "M" });
    }
    let Fromdate = taskListArrays.controls[i].value['CutOffDateFrom']
    let date = taskListArrays.controls[i].value['CutOffDate']
    if (date <= Fromdate) {
      taskListArrays.controls[i].get('CutOffDate').setErrors({ dateError: true });
      // this.errorcheckValidator(i)
    }
    else {
      taskListArrays.controls[i].get('CutOffDate').setErrors(null);
    }
  }

  selectSessionID(id) {
    this.Table = false;
    sessionStorage.setItem('SessionID', id);
  }

  fetchCourse(id) {
    this.Table = false;
    const payload = {};
    payload['CoCgCgCode'] = id;
    payload['SessionID'] = sessionStorage.getItem('SessId');
    this.umsService.getSessionColgCo(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      this.filteredCourseList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  getNextDay(selectedDate: Date): Date {
    if (selectedDate) {
      const nextDay = new Date(selectedDate);
      nextDay.setDate(selectedDate.getDate() + 1);
      return nextDay;
    }
    // If no date is selected, allow any date.
    return null;
  }

  getFormControls() {
    return (this.SessionCutOff.get('DateArray') as FormArray).controls;
  }


  addBtn() {
    this.disableDate = false
    const creds = this.SessionCutOff.controls.DateArray as FormArray;
    // this.action('d'); 
    // this.addNew()
    if (creds.invalid) {
      creds.controls.forEach(element => {
        element.get('CutOffDate').markAsTouched();
        element.get('CutOffDateFrom').markAsTouched();
        // element.get('OpMin').markAsTouched();
        // element.get('OpMax').markAsTouched();
      })
    } else {
      this.subButton = false;
      this.addNew()
    }
  }

  addNew() {
    const creds = this.SessionCutOff.controls.DateArray as FormArray;
    creds.push(
      this.fb.group({
        CutOffDate: new FormControl('', [Validators.required]),
        CutOffDateFrom: new FormControl('', [Validators.required]),
        AMD: new FormControl("A"),
      })
    );
  }

  initLoad() {
    let idd = '';
    this.editButton = false;
    this.submitButton = true;
    //  this.SessionCutOff.reset();
    this.isdisabled = false
    this.fetchSession(idd);
    // this.fetchSecretData();
    
    this.SessionCutOff = this.fb.group({
      DateArray: this.fb.array([]),
      SessionID: new FormControl('', [Validators.required]),
      CoCgCgCode: new FormControl('', [Validators.required]),
      CoCgCoCode: new FormControl([], [Validators.required]),
      CoFcCode:new FormControl('', [Validators.required]),
      EmId: new FormControl([], [Validators.required]),
      InCode: new FormControl('', [Validators.required]),
      SearchString: new FormControl(''),
      AMD: new FormControl('A'),
    });
    // this.addNew();
  }

  fetchSession(id) {
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      this.sessionList = [];
      this.SessionFilterList = [];
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  fetchCollege() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
  }
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    payload['FcCode']=this.SessionCutOff.value.CoFcCode;
    this.umsService.getCollege (payload).subscribe(res => {
    if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });

  }

  NewSearchCoSch(ShId) {
    const payload = {};
    payload['CEcShId'] = ShId;
    this.umsService.NewSearchCoSch(payload).subscribe(res => {
      if (res.status) {

        // this.RegnForm(res.data[0]['CEcId'])
      }
      else {
        this.CoEdit(ShId)
      }
    });
  }

  // NewCoSch2() {
  //   let payload2 = {}
  //   payload2 = this.SessionCutOff.value;
  //   const payload = {};
  //   payload['CoCode'] = payload2['CoCgCoCode'];;
  //   payload['CShStatus'] = '';
  //   payload['LoginId'] = sessionStorage.getItem('userId');
  //   payload['CShSnNo'] = parseInt(payload2['SessionID']);
  //   this.umsService.NewCoSch(payload).subscribe(res => {
  //     if (res.status) {
  //       this.NewSearchCoSch(res.data[0]['CShId'])
  //     }
  //   });
  // }

  submitFun1() {
    this.DateArray = this.SessionCutOff.get('DateArray') as FormArray;
    // this.action('d'); 
    // if (this.DateArray.invalid) {
    //   this.DateArray.controls.forEach(element => {
    //     element.get('CutOffDate').markAsTouched();
    //     element.get('CutOffDateFrom').markAsTouched();
    //   })
    // }
    // if (this.SessionCutOff.invalid) {
    //   this.SessionCutOff.get('SessionID').markAsTouched();
    //   this.SessionCutOff.get('CoCgCgCode').markAsTouched();
    //   this.SessionCutOff.get('CoCgCoCode').markAsTouched();
    //   // let x = (this.SessionCutOff.get('DateArray') as FormArray).controls;
    //   // x.forEach(element => {
    //   //   // element['controls']['CutOffDate'].markAsTouched();
    //   // });

    // }
    if (this.selectedCourses.length > 0) {
      this.SessionCutOff.controls['CoCgCoCode'].setValue(this.selectedCourses);
    }
    if (this.selectedExams.length > 0) {
      this.SessionCutOff.controls['EmId'].setValue(this.selectedExams);
    }

    console.log(this.SessionCutOff.errors)
    if (this.SessionCutOff.invalid) {
      this.subButton = false;
      const requiresExam = this.SessionCutOff.value.InCode === 'EMFRM' || this.SessionCutOff.value.InCode === 'EMFEE' ||
                            this.SessionCutOff.value.InCode === 'MRKEN' || this.SessionCutOff.value.InCode === 'SubSe' ||
                            this.SessionCutOff.value.InCode === 'MRKL' || this.SessionCutOff.value.InCode === 'Attnd' ||
                            this.SessionCutOff.value.InCode === 'IaAtt' || this.SessionCutOff.value.InCode === 'IAMar' ||
                            this.SessionCutOff.value.InCode === 'ASC';
      if (requiresExam) {
        if (this.selectedExams.length > 0) {
          this.SessionCutOff.controls['EmId'].setValue(this.selectedExams);
        }
        this.SessionCutOff.get('EmId').setValidators([Validators.required]);
        this.SessionCutOff.get('EmId').updateValueAndValidity();
        this.SessionCutOff.get('EmId').markAsTouched();
      } else {
        this.SessionCutOff.get('EmId').clearValidators();
        this.SessionCutOff.get('EmId').updateValueAndValidity();
        this.SessionCutOff.get('EmId').markAsUntouched();
      }
      this.SessionCutOff.get('SessionID').markAsTouched();
      this.SessionCutOff.get('CoCgCgCode').markAsTouched();
      this.SessionCutOff.get('CoCgCoCode').markAsTouched();
      this.SessionCutOff.get('InCode').markAsTouched();
      let x = (this.SessionCutOff.get('DateArray') as FormArray).controls;
      x.forEach(element => {
        element['controls']['CutOffDate'].markAsTouched();
        element['controls']['CutOffDateFrom'].markAsTouched();
      });
      
    }
    else {
      this.subButton = true;
      if(this.SelectAllActive == true){
        this.submitAll();
      }
      else if(this.SelectAllActive == false){ 
        this.submit();
      }
      
      // this.courseShId()
    }
  }

  // courseShId() {
  //   const payload = {};
  //   payload['CoCode'] = this.SessionCutOff.value['CoCgCoCode']
  //   payload['CShStatus'] = '';
  //   payload['LoginId'] = sessionStorage.getItem('userId');
  //   payload['CShSnNo'] = this.SessionCutOff.value['SessionID']
  //   this.umsService.NewCoSch(payload).subscribe(res => {
  //     if (res.status) {
  //       this.checkRegister(res.data[0]['CShId'])
  //     }
  //     else{
  //       let data = {}
  //         data['message'] = "Course Is Not Scheduled. First Open Schedule For This Course and Open Its Registration List"
  //         data['title'] = 'Information'
  //         data['icon'] = 'fas fa-box'
  //         this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //     }
  //   });
  // }
  // checkRegister(ShId) {
  //   const payload = {};
  //   payload['CEcInCode'] = 51;
  //   payload['CEcShId'] = ShId;
  //   payload['CEcOpId'] = sessionStorage.getItem('userId');
  //   this.umsService.getSupCourseEditRecord(payload).subscribe(res => {
  //     if (res.status) {
  //       this.submit();
  //     }
  //     else{
  //       let data = {}
  //       data['message'] = "Course Registration List Not Open. First Open Registration List For This Course"
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-box'
  //       this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //     }
  //   });
  // }

  CourseData(data) {
    this.CoCode = data.CoCgCoCode;
    this.CoName = data.CoName;
    this.SnNo = data.SessionID;

  }

  prepopulatedData(e) {
    this.DateArray = this.SessionCutOff.get('DateArray') as FormArray;
    this.DateArray.clear();
    let payload = {}
    payload['SessionID'] = e.SessionID;
    payload['CoCgCgCode'] = this.commaSeparatedColleges != undefined ? this.commaSeparatedColleges : e.CoCgCgCode;
    
    // CoCgCoCode – send as CSV if array, else as string
    const coCodes = Array.isArray(e.CoCgCoCode) ? e.CoCgCoCode.join(',') : e.CoCgCoCode;
    payload['CoCgCoCode'] = coCodes;
    
    payload['InCode'] = e.InCode;
    
    // EmId – use commaSeparatedExams if available, else join array, else fallback to '0'
    let emIdParam = this.commaSeparatedExams || (Array.isArray(e.EmId) ? e.EmId.join(',') : e.EmId);
    if (!emIdParam) emIdParam = '0';   // if no exams selected, send '0' (means all exams in SP)
    payload['EmId'] = emIdParam;
    
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      if (res.status) {
        this.editButton = true;
        this.submitButton = false;
        this.DateArray = this.SessionCutOff.get('DateArray') as FormArray;
        this.DateArray.clear();
        this.Table = true;
        res.data.forEach(element => {
          const creds = this.SessionCutOff.controls.DateArray as FormArray;
          creds.push(
            this.fb.group({
              CutOffDate: new FormControl(this.datepipe.transform(element.CutOffDate, 'yyyy-MM-dd'), [Validators.required]),
              CutOffDateFrom: new FormControl(this.datepipe.transform(element.CutOffDateFrom, 'yyyy-MM-dd'), [Validators.required]),
              AMD: new FormControl("M"),
              SessionCoColgCutOffDtId: new FormControl(element.SessionCoColgCutOffDtId),
            })
          );
        });
      } else {
        this.editButton = false;
        this.submitButton = true;
        //this.DateArray = this.SessionCutOff.get('DateArray') as FormArray;
        this.DateArray.clear();
        this.Table = true;
        this.addNew();
      }
    });
  }

  prepopulateRecord(e) {
  this.spinner.show();
  this.editButton = true;
  this.submitButton = false;
  this.isdisabled = true;
  this.SelectAllActive = false;
    const payload = {};
  this.fetchSession('');
    // this.fetchSecretData();
    this.fetchCollege();
    payload['SessionID'] = e.SessionID;
    payload['CoCgCgCode'] = e.CoCgCgCode;
    payload['CoCgCoCode'] = e.CoCgCoCode;
    payload['InCode'] = e.InCode;
    payload['EmId'] = e.EmId;
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.Table = true
        this.SelectAllActive = false;
        // Split comma-separated values into arrays for multi-select
        const coCodeArray = e.CoCgCoCode ? e.CoCgCoCode.split(',') : [];
        const emIdArray = e.EmId ? e.EmId.split(',') : [];
        // Set selected arrays
        this.selectedCourses = coCodeArray;
        this.selectedExams = emIdArray;
        this.commaSeparatedCourses = e.CoCgCoCode;
        this.commaSeparatedExams = e.EmId;

        if(res.data[0]['InCode'] == 'EMFRM' || res.data[0]['InCode'] == 'EMFEE' || res.data[0]['InCode'] == 'MRKEN' || res.data[0]['InCode'] == "MRKL" || res.data[0]['InCode'] == "SubSe" || res.data[0]['InCode'] == "Attnd" || res.data[0]['InCode'] == 'IaAtt' || res.data[0]['InCode'] == 'ASC'){
          const courseCodes = coCodeArray.length > 0 ? coCodeArray.join(',') : res.data[0]['CoCgCoCode'];
          this.fetchSupExamRecord(courseCodes); 
          this.examDropdownVisible = true
        }

        this.fetchCourse1(res.data[0]['CoCgCgCode'], e.SessionID)
        // this.fetchCourse(res.data[0]['CoCgCgCode']);
        this.SessionCutOff.patchValue({
          SessionID: res.data[0]['SessionID'],
          CoCgCgCode: res.data[0]['CoCgCgCode'],
          CoCgCoCode: coCodeArray,
          EmId: emIdArray,
          InCode: res.data[0]['InCode']
        });
        res.data.forEach(element => {
          this.prepopulateNew(element);
        });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
    }

  fetchCourse1(id, session) {
    this.Table = false;
    const payload = {};
    payload['CoCgCgCode'] = id;
    payload['SessionID'] = session;
    this.umsService.getSessionColgCo(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
         const CoCode= this.SessionCutOff.value.CoCgCoCode;

         this.umsService.getCourse({CoCode:CoCode}).subscribe(res=>{

          if(res.status){
          

            this.SessionCutOff.patchValue({
            CoFcCode:res.data[0].CoFcCode
        })
           this.fetchFacultyCode()
          }
         })
       
        const fcCode=this.CourseList.filter((c:any)=>c.CoCode===CoCode);
      
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      this.filteredCourseList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  prepopulateNew(e) {
    this.Table = true
    this.action('d');
    const creds = this.SessionCutOff.controls.DateArray as FormArray;
    creds.push(
      this.fb.group({
        CutOffDate: new FormControl(this.datepipe.transform(e.CutOffDate, 'yyyy-MM-dd'), [Validators.required]),
        CutOffDateFrom: new FormControl(this.datepipe.transform(e.CutOffDateFrom, 'yyyy-MM-dd'), [Validators.required]),
        AMD: new FormControl(""),
        SessionCoColgCutOffDtId: new FormControl(e.SessionCoColgCutOffDtId),
      })
    );
  }


  CoEdit(Shid) {
    const payload = {};
    payload['CEcShId'] = Shid;
    payload['CEcDesc'] = 'New';
    payload['CEcInCode'] = 51;
    payload['CEcOpId'] = sessionStorage.getItem('userId');
    payload['CEcOpenOpId'] = sessionStorage.getItem('userId');
    payload['CEcStatus'] = 'O';
    payload['FrontCEcInCode'] = 51;
    payload['FrontList'] = '';
    payload['CEcListNo'] = '';
    payload['EcId'] = '';
    this.umsService.submitSupCourse(payload).subscribe(res => {
      if (res.status) {
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  NewCoSch() {
    this.submitpayload = this.SessionCutOff.value
    const payload = {};
    payload['CoCode'] = this.submitpayload['CoCgCoCode'];
    payload['CShStatus'] = '';
    payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
    payload['CShSnNo'] = this.submitpayload['SessionID'];
    this.umsService.NewCoSch(payload).subscribe(res => {
      if (res.status) {
        this.ShId = res.data['CShId']
        this.NewSearchCoSch(res.data[0]['CShId'])

      }
      else {
        this.CoSch();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  CoSch() {
    this.submitpayload = this.SessionCutOff.value
    const payload = {};
    payload['CShCoCode'] = this.CoCode;
    payload['CoName'] = this.CoName;
    payload['CShStatus'] = 'O';
    payload['CShPath'] = '';
    payload['CShId'] = '';
    payload['CShSnNo'] = this.submitpayload['SessionID'];
    this.umsService.addCoSch(payload).subscribe(res => {
      if (res.status) {
        this.NewCoSch()

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  submit1() {
  this.spinner.show();
    let payload = {}
    payload = this.SessionCutOff.value;

  let iserror = false;

  var bar = new Promise<void>((resolve, reject) => {
    payload['DateArray'].forEach((element, index, array) => {
      let arr1 = [];
      arr1.push(
        this.fb.group({
          SessionID: new FormControl(payload['SessionID']),
          CoCgCgCode: new FormControl(payload['CoCgCgCode']),
          CoCgCoCode: new FormControl(payload['CoCgCoCode']),
          CutOffDate: new FormControl(this.datepipe.transform(element['CutOffDate'], 'yyyy-MM-dd')),
          CutOffDateFrom: new FormControl(this.datepipe.transform(element['CutOffDateFrom'], 'yyyy-MM-dd')),
          AMD: new FormControl(element['AMD']),
          SessionCoColgCutOffDtId: new FormControl(element['SessionCoColgCutOffDtId'] ? element['SessionCoColgCutOffDtId'] : 0),

        })
        )
        if (arr1[0].value["AMD"] == "M") {
          this.umsService.updateSessionCutOff(arr1[0].value).subscribe(res => {
            this.spinner.hide();
            if (res.status == false) {
            this.spinner.hide();
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false
              this.errMsg = res.message
            }
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          });
        } else if (arr1[0].value["AMD"] == "A") {
          this.umsService.addSessionCutOff(arr1[0].value).subscribe(res => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false
              this.errMsg = res.message
              // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
            }
            if (res.status == true) {
              iserror = false
              this.errMsg = res.message
              // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
            }
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          });
          }

    });
    })
  bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close()
        });
    } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    }
  });
  }


  submit() {
    let payload = {}
    payload = this.SessionCutOff.value;
    const coCodes = Array.isArray(payload['CoCgCoCode']) ? payload['CoCgCoCode'].join(',') : payload['CoCgCoCode'];
    const emIds = Array.isArray(payload['EmId']) ? payload['EmId'].join(',') : payload['EmId'];

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
    SessionID: payload['SessionID'],
        CoCgCgCode: payload['CoCgCgCode'],
    CoCgCoCode: coCodes,
    EmId: emIds,
    InCode: payload['InCode'],
        CutOffDate: payload['DateArray'][0]['CutOffDate'],
        CutOffDateFrom: payload['DateArray'][0]['CutOffDateFrom'],
        SessionCoColgCutOffDtId: payload['DateArray'][0]['SessionCoColgCutOffDtId'],

      },
  };

  this.httpClient.delete(this.APIService + '/students/SessionCoColgCutOff', options)
      .subscribe((s) => {
        let cc = [];
        cc.push(s);
        this.AddSessionCutOff();
      }, (ERROR: HttpErrorResponse) => {
        this.subButton = false
      });
      }

  AddSessionCutOff() {
  this.spinner.show();
    let payload = {}
    payload = this.SessionCutOff.value;

    // Prepare comma-separated strings for multi-select fields
    const coCodes = Array.isArray(payload['CoCgCoCode']) ? payload['CoCgCoCode'].join(',') : payload['CoCgCoCode'];
    const emIds = Array.isArray(payload['EmId']) ? payload['EmId'].join(',') : payload['EmId'];

  let iserror = false;

  var bar = new Promise<void>((resolve, reject) => {
    payload['DateArray'].forEach((element, index, array) => {
      let arr1 = [];
      arr1.push(
        this.fb.group({
          SessionID: new FormControl(payload['SessionID']),
          CoCgCgCode: new FormControl(payload['CoCgCgCode']),
          CoCgCoCode: new FormControl(coCodes),
          EmId: new FormControl(emIds),
          InCode: new FormControl(payload['InCode']),
          CutOffDate: new FormControl(this.datepipe.transform(element['CutOffDate'], 'yyyy-MM-dd')),
          CutOffDateFrom: new FormControl(this.datepipe.transform(element['CutOffDateFrom'], 'yyyy-MM-dd')),
          SessionCoColgCutOffDtId: new FormControl(element['SessionCoColgCutOffDtId'] ? element['SessionCoColgCutOffDtId'] : 0),
        })
        )
        this.umsService.addSessionCutOff(arr1[0].value).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
          }
          if (res.status == true) {
            iserror = false
            this.errMsg = res.message
            // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
    });
  });
    })
  bar.then(() => {
      if (iserror == false) {
      this.subButton = true;
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close()
      });
    } else {
      this.subButton = false;
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    }
  });
  }



  redirect(to): void {
    // this.spinner.show()
    this.router.navigate([to]);
    //this.spinner.hide();
  }


  errorcheck(i) {
    return i.controls['CutOffDate'].touched && i.controls['CutOffDate'].errors?.required
  }
  errorcheckValidator(i) {
    return i.controls['CutOffDate'].touched && i.controls['CutOffDate'].errors?.pattern
  }

  errorcheck1(i) {

    return i.controls['CutOffDateFrom'].touched && i.controls['CutOffDateFrom'].errors?.required
  }
  // errorcheckValidator1(i) {
  //   return i.controls['CutOffDateFrom'].touched && i.controls['CutOffDateFrom'].errors?.pattern
  // }

  deleteRow(index) {

    if (index !== 0) {
      this.DateArray = this.SessionCutOff.controls.DateArray.value
      this.datearr = this.DateArray[index];
      const cutoffDateFrom = new Date(this.datearr['CutOffDateFrom']);
      const currentDate = new Date(this.date);
      const CutOffDate = new Date(this.datearr['CutOffDate'])
      if (currentDate > cutoffDateFrom && currentDate < CutOffDate) {
        let data = {}
        data['message'] = 'Active Cutoff Dates Cannot Be Deleted'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
      else {
        (<FormArray>this.SessionCutOff.get("DateArray")).removeAt(index);
      }
    }
    else {
      let data = {}
      data['message'] = "First Row Can Not Be Deleted"
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    }

    // let taskListArrays = this.SessionCutOff.get('DateArray') as FormArray;
    // for (let i = index - 1; i >= 0; i--) {
    //   const currentRow = taskListArrays.controls[i];
    //   currentRow.patchValue({ "AMD": "D" });


    // }


  }



  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        let activeFlowObject = res.projectPharam['ActiveFlow']
        let arrActiveFlow = JSON.parse(activeFlowObject);
        if(arrActiveFlow[0]['CutOffDateAllClg'] == 1){
          this.SelectAllActive = true;
          this.GetUserWise()
          // this.fetchCourse2()
        }
        else if(arrActiveFlow[0]['CutOffDateAllClg'] == 0){
          this.SelectAllActive = false;
          this.fetchCollege();
        }

      }
      else{
        this.spinner.hide()
      }
      this.fetchFacultyCode()
      // this.fetchSupExamRecord(res.projectPharam['SnNo']);
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      }
    );
  }

  fetchSupExamRecord(CoCode: any) {
    let codeParam: string;
    if (Array.isArray(CoCode)) {
      codeParam = CoCode.join(',');
    } else {
      codeParam = CoCode;
    }
    if (!codeParam) {
      this.ExamAList = [];
      this.filteredExamAList = [];
      return;
    }
    this.spinner.show();
    let payload = {};
    payload['EmCoCode'] = codeParam;   
    this.umsService.getExam(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ExamAList = res.data;
        this.filteredExamAList = this.ExamAList.slice();
      } else {
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    );
  }

  fetchSupExamInputs() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'ACT';
    this.umsService.getCode(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ExamInputList = res.data;
        this.filteredExamInputList = this.ExamInputList.slice();
      } else {
        this.ExamAList = [];
        this.filteredExamInputList = this.ExamInputList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamInputList = this.ExamInputList.slice();
      })
  }

  toggleExamDropdown(selectedItem: any) {
    if (selectedItem === "EMFRM" || selectedItem === "EMFEE" || selectedItem === "MRKEN" || selectedItem === "SubSe" || selectedItem == "MRKL" || selectedItem == "Attnd" || selectedItem == 'IaAtt' || selectedItem == 'IAMar' || selectedItem == 'ASC') {
      this.examDropdownVisible = true;
    } else {
      this.examDropdownVisible = false;
    }
    if (selectedItem === "EMFRM" || selectedItem === "EMFEE" || selectedItem === "MRKEN" || selectedItem === "SubSe" || selectedItem == "MRKL" || selectedItem == "Attnd" || selectedItem == 'IaAtt' || selectedItem == 'IAMar' || selectedItem == 'ASC') {
      this.examDropdownVisible = true;
    }
    else {
      this.SessionCutOff.controls['EmId'].setValue([]);
      this.prepopulatedData(this.SessionCutOff.value)
    }

  }
  getdates() {
    this.prepopulatedData(this.SessionCutOff.value)
  }

  GetUserWise(){
    this.spinner.show();
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    this.umsService.GetUserWise(payload).subscribe((res) => {
      if(res.status){
        // this.collegeList = res.data;
        // this.filteredCollegeList = this.collegeList.slice();
        this.collegeList = [];
        this.filteredCollegeList = [];
        this.spinner.hide();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

selectAllColleges() {
    if (this.isAllCollegesSelected()) {
    // remove all
      this.selectedColleges = [];
    this.SessionCutOff.controls['CoCgCgCode'].setValue([], { emitEvent: false });
      this.commaSeparatedColleges = '';
    } else {
    // select all
    this.selectedColleges = this.filteredCollegeList.map(item => item.CgCode);
    this.SessionCutOff.controls['CoCgCgCode'].setValue(this.selectedColleges, { emitEvent: false });
      this.commaSeparatedColleges = this.selectedColleges.join(',');
    }
  this.isSelectAll = this.isAllCollegesSelected();
}
onCollegeSelect(event: any) {
  let selected = event.value ? [...event.value] : [];
  selected = selected.filter((item: any) => item !== 'selectAll');
  this.selectedColleges = selected;
  this.SessionCutOff.controls['CoCgCgCode'].setValue(selected, { emitEvent: false });
  this.commaSeparatedColleges = this.selectedColleges.join(',');
  this.isSelectAll = this.isAllCollegesSelected();
}

  // Helper method to check if all colleges are selected
  isAllCollegesSelected(): boolean {
    return this.selectedColleges.length === (this.filteredCollegeList?.length || 0);
  }

 onCourseSelect(event: any) {
  let selected = event.value ? [...event.value] : [];
  selected = selected.filter((item: any) => item !== 'selectAll');
  this.selectedCourses = selected;
  this.SessionCutOff.controls['CoCgCoCode'].setValue(selected, { emitEvent: false });
  this.commaSeparatedCourses = this.selectedCourses.join(',');

  // Clear previous exam selection when course changes
  this.selectedExams = [];
  this.commaSeparatedExams = '';
  this.SessionCutOff.controls['EmId'].setValue([]);

    // Fetch colleges and exams for ALL selected courses (pass the entire array)
    const fcCode = this.SessionCutOff.value.CoFcCode;
    if (this.selectedCourses.length > 0 && fcCode) {
      // For colleges, we may still fetch for the first course (or adjust as needed)
      const firstCourse = this.selectedCourses[0];
      this.fetchCollegeForCourse(firstCourse, fcCode);
      this.fetchSupExamRecord(this.selectedCourses);
  } else {
    // Clear college and exam lists if no course selected or no faculty
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.ExamAList = [];
    this.filteredExamAList = [];
  }
}

selectAllCourses() {
  if (this.isAllCoursesSelected()) {
    // Deselect all
    this.selectedCourses = [];
    this.SessionCutOff.controls['CoCgCoCode'].setValue([], { emitEvent: false });
    this.commaSeparatedCourses = '';
    this.selectedExams = [];
    this.commaSeparatedExams = '';
    this.SessionCutOff.controls['EmId'].setValue([]);
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.ExamAList = [];
    this.filteredExamAList = [];
  } else {
    // Select all
    this.selectedCourses = this.filteredCourseList.map(item => item.CoCgCoCode);
    this.SessionCutOff.controls['CoCgCoCode'].setValue(this.selectedCourses, { emitEvent: false });
    this.commaSeparatedCourses = this.selectedCourses.join(',');
    // Clear previous exam selection
    this.selectedExams = [];
    this.commaSeparatedExams = '';
    this.SessionCutOff.controls['EmId'].setValue([]);
    // Fetch colleges and exams for ALL selected courses
    const fcCode = this.SessionCutOff.value.CoFcCode;
    if (this.selectedCourses.length > 0 && fcCode) {
        const firstCourse = this.selectedCourses[0];
      this.fetchCollegeForCourse(firstCourse, fcCode);
      this.fetchSupExamRecord(this.selectedCourses);
    }
  }
}
  isAllCoursesSelected(): boolean {
    // Safeguard against undefined filteredCourseList
    return this.selectedCourses.length === (this.filteredCourseList?.length || 0);
  }
selectAllExams() {
  if (this.isAllExamsSelected()) {
    this.selectedExams = [];
    this.SessionCutOff.controls['EmId'].setValue([], { emitEvent: false });
    this.commaSeparatedExams = '';
  } else {
    this.selectedExams = this.filteredExamAList.map(item => item.EmId);
    this.SessionCutOff.controls['EmId'].setValue(this.selectedExams, { emitEvent: false });
    this.commaSeparatedExams = this.selectedExams.join(',');
  }
  this.getdates();
}

onExamSelect(event: any) {
  let selected = event.value ? [...event.value] : [];
  selected = selected.filter((item: any) => item !== 'selectAll');
  this.selectedExams = selected;
  this.SessionCutOff.controls['EmId'].setValue(selected, { emitEvent: false });
  this.commaSeparatedExams = this.selectedExams.join(',');
  this.getdates();
}

  isAllExamsSelected(): boolean {
    // Safeguard against undefined filteredExamAList
    return this.selectedExams.length === (this.filteredExamAList?.length || 0);
  }

  fetchCourse2() {
    this.Table = false;
    const payload = {};
    payload['CgCode'] = '';
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      this.filteredCourseList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  submitAll() {
    this.spinner.show()
    let payload = {}
    payload = this.SessionCutOff.value;
    const coCodes = Array.isArray(payload['CoCgCoCode']) ? payload['CoCgCoCode'].join(',') : payload['CoCgCoCode'];
    const emIds = Array.isArray(payload['EmId']) ? payload['EmId'].join(',') : payload['EmId'];

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
    SessionID: payload['SessionID'],
        CoCgCgCode: this.commaSeparatedColleges,
    CoCgCoCode: coCodes,
    EmId: emIds,
    InCode: payload['InCode'],
    CutOffDate: payload['DateArray'][0]['CutOffDate'],
    CutOffDateFrom: payload['DateArray'][0]['CutOffDateFrom'],
    SessionCoColgCutOffDtId: payload['DateArray'][0]['SessionCoColgCutOffDtId'],

      },
  };

  this.httpClient.delete(this.APIService + '/students/SessionCoColgCutOff', options)
      .subscribe((s) => {
        let cc = [];
        cc.push(s);
        this.AddSessionCutOffAll();
      }, (ERROR: HttpErrorResponse) => {
        this.subButton = false
        this.spinner.hide();
      });   
      }

  AddSessionCutOffAll() {
  this.spinner.show();
    let payload = {}
    payload = this.SessionCutOff.value;

    const coCodes = Array.isArray(payload['CoCgCoCode']) ? payload['CoCgCoCode'].join(',') : payload['CoCgCoCode'];
    const emIds = Array.isArray(payload['EmId']) ? payload['EmId'].join(',') : payload['EmId'];

  let iserror = false;

  var bar = new Promise<void>((resolve, reject) => {
    payload['DateArray'].forEach((element, index, array) => {
      let arr1 = [];
      arr1.push(
        this.fb.group({
          SessionID: new FormControl(payload['SessionID']),
            CoCgCgCode: new FormControl(this.commaSeparatedColleges),
          CoCgCoCode: new FormControl(coCodes),
          EmId: new FormControl(emIds),
          InCode: new FormControl(payload['InCode']),
          CutOffDate: new FormControl(this.datepipe.transform(element['CutOffDate'], 'yyyy-MM-dd')),
          CutOffDateFrom: new FormControl(this.datepipe.transform(element['CutOffDateFrom'], 'yyyy-MM-dd')),
          SessionCoColgCutOffDtId: new FormControl(element['SessionCoColgCutOffDtId'] ? element['SessionCoColgCutOffDtId'] : 0),
          UserId: new FormControl(sessionStorage.getItem('userId')),
        })
        )
        this.umsService.addSessionCutOff(arr1[0].value).subscribe(res => {
          // this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
          }
          if (res.status == true) {
            iserror = false
            this.errMsg = res.message
            // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
    });
  });
    })
  bar.then(() => {
      if (iserror == false) {
        this.subButton = true;
    this.spinner.hide();
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close()
        });
    } else {
        this.subButton = false;
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    }
  });
  }
    fetchFacultyCode() {
  this.umsService.getFaculty({}).subscribe(res => {
    if (res.status) {
      this.fcCodeList = res.data || [];
      this.filteredListFcCode = [...this.fcCodeList];
      console.log("this.fcCodeList",this.fcCodeList)
      
      this.fetchCourseCode('')
    }
  });
}
 
   onFacultyChange(fcCode: string) {
  this.CourseList = [];
  this.collegeList = [];
  this.SessionCutOff.patchValue({ CoCgCoCode: [], CoCgCgCode: '' });
  this.selectedCourses = [];
  this.commaSeparatedCourses = '';
  this.selectedExams = [];
  this.commaSeparatedExams = '';
  this.SessionCutOff.controls['EmId'].setValue([]);
 
  if (fcCode) {
    this.fetchCourseCode(fcCode);
  }
}
  fetchCourseCode(fcCode) {
   const payload = {
    FcCode: fcCode,
    SessionID: this.SessionCutOff.value.SessionID
  };
  this.umsService.getCourses(payload).subscribe(res => {
    if (res.status) {
      this.CourseList = res.data || [];
      this.filteredCourseList = [...this.CourseList];
      console.log("this.CourseList",this.CourseList)
    }
  });
}
  onCourseChange(coCode: string) {
  this.collegeList = [];
  this.SessionCutOff.patchValue({ CoCgCgCode: '' });
  const fcCode = this.SessionCutOff.value.CoFcCode; 
  if (coCode && fcCode) {
    this.fetchCollegeForCourse(coCode, fcCode);
  }
}
  fetchCollegeForCourse(coCode: string, fcCode: string) {
    const payload = {
      CoCode: coCode,
      FcCode: fcCode,
      SessionID: this.SessionCutOff.value.SessionID,
    };
    this.umsService.getCollegeFaculty(payload).subscribe((res: any) => {
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    });
  }

}